module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-question/master-question.component.scss
// module id = ./src/app/master/master-question/master-question.component.scss
// module chunks = main